import { Observable } from 'rxjs';
import { GeoPoint } from '../models/address/address.model';
import { Branch } from '../models/branch/branch.model';

/** Токен не нужен: филиал выбирается до входа. Нет ни одного филиала с координатами → ApiError('branch_not_found'). */
export abstract class BranchApi {
  abstract closest(point: GeoPoint): Observable<Branch>;
  /** Полный список филиалов организации: для самовывоза человек выбирает сам, а не по координатам. */
  abstract list(): Observable<Branch[]>;
  /** Филиалы с расстоянием: без координат сюда не попадают, поэтому дополняет `list()`, а не заменяет. */
  abstract nearby(point: GeoPoint): Observable<Branch[]>;
}
